function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14645 4.14645C3.34171 3.95118 3.65829 3.95118 3.85355 4.14645L6 6.29289L8.14645 4.14645C8.34171 3.95119 8.65829 3.95119 8.85355 4.14645C9.04882 4.34171 9.04882 4.65829 8.85355 4.85355L6.35355 7.35355C6.15829 7.54882 5.84171 7.54882 5.64645 7.35355L3.14645 4.85355C2.95118 4.65829 2.95118 4.34171 3.14645 4.14645Z"
  }));
};

export default SvgComponent;